

export const HEADING_STYLES = {
    white: {
        color: "white",
        textShadow: "0 1px 3px rgba(0, 0, 0, 0.8)",
    },
    default: {
        color: "black",
    },
};
